<template>
  <x-form ref="xFormRef" v-model:sending=sending @submit="wizard.nextStep" submit-text="" @check-validity="valid = $event" :class="{'pf-v6-u-display-none': hidden}">
    <pf-flex justify-content="space-between">
      <pf-flex-item align-self="flex-start">
        <pf-title h="2">{{ title }}</pf-title>
      </pf-flex-item>

      <pf-flex-item align-self="flex-end">
        <pf-action-group>
          <slot name="actions">
            <pf-button
              v-if="confirm"
              class="pf-v6-u-display-none pf-v6-u-display-flex-on-sm"
              variant="tertiary"
              @click="wizard.goToStep(wizard.initialStep)"
              ouia-id="wizard-form-actions-restart"
            >
              <template #icon>
                <angles-left-icon />
              </template>
              {{ $t('Ricomincia') }}
            </pf-button>

              <pf-button
                class="pf-v6-u-display-none pf-v6-u-display-flex-on-sm"
                variant="tertiary"
                :disabled="previousDisabled"
                @click="wizard.resetWizard(false)"
                ouia-id="wizard-form-actions-reset"
              >
                {{ $t('Reset') }}
              </pf-button>

              <pf-button
                :disabled="previousDisabled"
                variant="tertiary"
                @click="wizard.previousStep"
                ouia-id="wizard-form-actions-previous"
              >
                <template #icon>
                  <angle-left-icon />
                </template>

                {{ previousLabel }}
              </pf-button>

            <pf-button
              v-if="confirm"
              variant="primary"
              href="#wizard-actions"
              ouia-id="wizard-form-actions-submit"
            >
              {{ $t('Concludi') }}
            </pf-button>
            <pf-button
              v-else
              type="submit"
              variant="primary"
              :aria-disabled="sending || !valid"
              :loading="sending"
              ouia-id="wizard-form-actions-next"
            >
              {{ nextLabel }}
              <template #icon>
                <angle-right-icon />
              </template>
            </pf-button>
          </slot>
        </pf-action-group>
      </pf-flex-item>
    </pf-flex>

    <slot />
  </x-form>
</template>

<style lang="scss">
.pf-v6-c-form__group.pf-m-action {
  margin: 0;
}
</style>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import { nextTick, ref, useTemplateRef, watch } from 'vue';
import { useWizard } from './composition';
import AngleLeftIcon from '@vue-patternfly/icons/angle-left-icon';
import AngleRightIcon from '@vue-patternfly/icons/angle-right-icon';
import AnglesLeftIcon from '@vue-patternfly/icons/angles-left-icon';
import XForm from '../x-form.vue';
import type { ComponentExposed } from 'vue-component-type-helpers';

const wizard = useWizard();

const props = withDefaults(defineProps<{
  title: string;
  hidden?: boolean;
  previousDisabled?: boolean;
  nextHidden?: boolean;
  nextLabel?: string;
  previousLabel?: string;
  confirm?: boolean;
}>(), {
  nextLabel: _t('Avanti'),
  previousLabel: _t('Indietro'),
});

const xForm = useTemplateRef<ComponentExposed<typeof XForm>>('xFormRef');
const sending = ref(false);
const valid = ref(false);

watch(()=> props.hidden, () => {
  if (!props.hidden) {
    nextTick(() => xForm.value?.fieldset?.checkValidity());
  }
});
</script>
